window.addEventListener("load", function(){
	if (document.body.classList.contains("pages-about")) {
	    jsAutoplay()
	} else {
		return false
	}
})